'use strict';

module Patersons {

    export class LandingCtrl {

        scope: Patersons.NavbarScope;
        location;
        window;
        stateParams;
        http: ng.IHttpService;
        tokenService: Patersons.TokenService;

        static $inject = ['$scope', '$location', '$window', '$state', '$stateParams', '$http', 'tokenService'];

        constructor($scope, $location, $window, $state, $stateParams, $http, tokenService) {
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.stateParams = $stateParams;
            this.http = $http;
            this.tokenService = tokenService;

            this.scope.editMode = false;
            this.scope.events = this;

            if (this.tokenService.tokenManager) {
                if (this.tokenService.tokenManager.expired) {
                    this.tokenService.tokenManager.redirectForToken();
                }
                else {
                    $state.go("dashboard");        
                }
            }
            else {
                $state.go("dashboard");        
            }
        }
    }
}
